import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import ViewProfile from "./ViewProfile";

const ViewProfileLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="View Profile" />
      <ViewProfile />
    </MasterLayout>
  );
};

export default ViewProfileLayout;
